import {
  BLOCKCHAINS,
  TEST_BLOCKCHAINS,
  type ChainData,
} from "@/constants/chain-details";
import type { NetworkType } from "@/types/general.types";

/**
 * Resolves a chain object based on the provided chain ID and network type.
 * This works with dynamic network env switching like
 */
export const resolveChainFromId = (
  chainId: number | string | undefined,
  networkType: NetworkType | undefined,
): ChainData | undefined => {
  if (!networkType) return;

  const chains = networkType === "mainnet" ? BLOCKCHAINS : TEST_BLOCKCHAINS;
  const chain = chains.find((chain) => chain.chainId === chainId);

  return chain;
};
